// extracted by mini-css-extract-plugin
module.exports = {"app":"app_app__3H5oe"};